import { computed, Directive, inject } from '@angular/core';
import { RtlProvider } from '../providers/rtl.provider';

@Directive({
  selector: '[cueRtl]',
  standalone: true,
  host: {
    '[attr.dir]': 'dir()',
  },
})
export class RtlDirective {
  localeService = inject(RtlProvider);
  dir = computed(() => {
    return this.localeService.rtl() ? 'rtl' : 'ltr';
  });
}
